import { hasWebGL2 } from "../persona/webgl-detect.mjs";

// Client lifecycle for the WebGL card deck. Runs only in the browser after the
// deck markup is mounted, and tears the GL context/listeners down on unmount.
// Mirrors the original HTMX beforeSwap/afterSettle boot but driven by Marko.
//
// Bandwidth optimization: `hasWebGL2()` is a tiny synchronous probe (~200 bytes)
// that runs before we ever fetch the heavy shader engine. If WebGL2 is
// unavailable we return early and the `import("../persona/deck.mjs")` chunk
// (which contains all GLSL strings and WebGL2 boilerplate) is never
// requested — the CSS `.deck-fallback` cards remain visible instead.
// This matches Marko 6's recommendation to keep feature detection in a
// lightweight module and gate heavy client-only imports via dynamic `import()`
// inside `<script>` with `$signal.onabort` for cleanup (see
// `node_modules/marko/cheatsheet.md` — `<script>` = reactive effect,
// cleanup via `$signal.onabort`).
<script>
  if (typeof window === "undefined") return;
  if (!hasWebGL2()) return;

  let cleanup;
  let cancelled = false;

  import("../persona/deck.mjs").then((mod) => {
    if (cancelled) return;
    cleanup = mod.mountPersonaDeck();
  });

  $signal.onabort = () => {
    cancelled = true;
    if (cleanup) cleanup();
  };
</script>

// Both the canvas (WebGL) and the overlay labels live here. The fallback
// (CSS) cards are provided separately by the landing page's .deck-fallback.
canvas#persona-deck role="img" aria-hidden="true"
div.deck-overlay
  for|card| of=input.cards
    a.card-label class=card.theme href=card.href data-card=card.index aria-label=card.aria
      div.game-logo -- ${card.logo}
      div.release-date -- ${card.release}
